import * as Yup from 'yup';

export const EditEducationFormValidationSchema = Yup.object().shape({
  RoleID: Yup.object().nullable().required('Role field is required'),

  DegreeID: Yup.object().nullable().required('Degree field is required'),

  CurrentSchoolID: Yup.object().nullable().required('School field is required'),

  OfficeLocationID: Yup.object()
    .nullable()
    .required('School location field is required'),

  endDate: Yup.object()
    .nullable()
    .when(['Present'], (Present, schema) => {
      if (Present) {
        return schema;
      }
      return schema.test(
        'required-endDate',
        'End Date field is required',
        value => value && value.month && value.year
      );
    }),

  startDate: Yup.object()
    .nullable()
    .test(
      'is-startDate',
      'Start Date field is  required',
      value => value && value.month && value.year
    )
    .when(['endDate', 'Present'], (endDate, Present, schema) => {
      if (Present || !endDate || !endDate.year || !endDate.month) {
        return schema;
      }
      return schema.test(
        'validate-startDate',
        'Start Date must be earlier than End Date',
        value => {
          if (value) {
            const sDate = new Date();
            sDate.setFullYear(value.year);
            sDate.setMonth(value.month);
            const eDate = new Date();
            eDate.setFullYear(endDate.year);
            eDate.setMonth(endDate.month);

            return sDate < eDate;
          }
          return false;
        }
      );
    }),

  Description: Yup.string().max(
    2000,
    'You have exceeded the maximum number of 2000 characters'
  ),

  Email: Yup.string().when(['Present'], (Present, schema) => {
    if (!Present) {
      return schema;
    }
    return schema
      .email('Email address is incorrect')
      .required('Email field is required');
  }),
});
